import Repository from "./Repository";

/*
    Entitlement (backend#103) — the ONE answer to "what does this customer
    have right now", in one place.

    GET /me/entitlement
        -> { plan:   { key, label, supported },
             status: "none" | "active" | "cancelling" | "paused" | "ended" | "unsupported",
             activeUntil: ISO 8601 | null,
             canCancel: boolean,
             billing: { known, hasAccount, renewsOn, nextPlan },
             access:  { keyStatus, provisioned } }

    Before this, Settings asked whether the cached user had a Stripe customer
    id, the Plans page asked live Stripe, the API Access panel asked
    api_credentials.status and the navbar asked api_plan — four signals that
    disagree for 1,221 accounts. A paid customer with no Stripe record read as
    the free plan, with no way to cancel (static#79).

    Two fields carry the design and are worth knowing before using this:

      canCancel     true only where a cancel would actually succeed. Gate the
                    cancel link on this, never on a column.
      billing.known false when Stripe could not be reached. The status is
                    still the best answer we have — the server deliberately
                    does not downgrade a paying customer because a third party
                    was unavailable — so treat it as "billing detail may be
                    missing", not as "unknown customer".

    The user is identified from the bearer token injected by Repository.js —
    there is no id in the path and none in the body.
*/

const entitlement = "/me/entitlement";

const EntitlementRepository = {
  getEntitlement() {
    return Repository.get(`${entitlement}`);
  },
};

export default EntitlementRepository;
